import { AuctionDto, BidDto } from '../../../services/Auction/auctionService.dto';
import { dateUtils } from '../../../utils/dateUtils';

export const isWinnerDetermined = (auction: AuctionDto) => {
  const { status, winningBidId } = auction;
  return (
    status === 'AWAITING_PAYMENT' ||
    status === 'CLOSED' ||
    status === 'COMPLETED' ||
    (isAuctionWaitingForEnd(auction) && !!winningBidId)
  );
};

export const findWinningBid = (auction: AuctionDto): BidDto => {
  return auction.bids.find(bid => bid.id === auction.winningBidId)!!;
};

export const extractItemPrice = (
  auction: AuctionDto
): { currentItemPrice: number | null; minBidPrice: number | null } => {
  if (!auction) {
    return { currentItemPrice: null, minBidPrice: null };
  } else if (auction.winningBidId) {
    const { amount: winningBidPrice } = findWinningBid(auction);
    return { currentItemPrice: winningBidPrice, minBidPrice: winningBidPrice + 1 };
  } else {
    return { currentItemPrice: auction.minimumPrice, minBidPrice: auction.minimumPrice };
  }
};

export const isAuctionExpired = (auction: AuctionDto) => {
  return auction.status !== 'ONGOING' || dateUtils.parseBackendDate(auction.endDateTime) < dateUtils.currentDate();
};

export const isAuctionWaitingForEnd = (auction: AuctionDto) =>
  auction.status === 'ONGOING' && dateUtils.parseBackendDate(auction.endDateTime) < dateUtils.currentDate();

export const isAuctionInProgress = (auction: AuctionDto) =>
  auction.status === 'ONGOING' && dateUtils.parseBackendDate(auction.endDateTime) >= dateUtils.currentDate();
